export default "__VITE_ASSET__CtfILReG__"